import * as R from "ramda";
import { bool, string, func, object } from "prop-types";

// import DropdownFacetBubbles from "../DropdownFacets/DropdownFacetBubbles.jsx";
import DropdownFacetBubbles from "./DropdownFacetBubbles.jsx";

const propTypes = {
  clearAllLabel: string.isRequired,
  clearAllFacets: func.isRequired,
  handleFacetClick: func.isRequired,
  response: object.isRequired,
  setShowMobileFacets: func.isRequired,
  showMobileFacets: bool.isRequired,
  activeFacets: object.isRequired,
  view: string.isRequired,
  setView: func.isRequired,
};

export const SelectedFacets = (props) => {
  const {
    clearAllLabel,
    clearAllFacets,
    handleFacetClick,
    response,
    setShowMobileFacets,
    showMobileFacets,
    activeFacets,
    view,
    setView,
  } = props;

  return (
    <div className="dropdown-facets__facet-bubbles">
      <DropdownFacetBubbles
        clearAllFacets={clearAllFacets}
        onFacetClick={handleFacetClick}
        totalResults={response?.totalResults}
        setFacetMenuOpen={setShowMobileFacets}
        facetMenuOpen={showMobileFacets}
        clearAllLabel={clearAllLabel}
        facets={response.facets}
        view={view}
        setView={setView}
        activeFacets={R.compose(
          R.when(
            (obj) => Object.keys(obj).length === 0,
            () => null,
          ),
          R.pickBy((val, key) => key !== "page"),
        )(activeFacets)}
      />
    </div>
  );
};

SelectedFacets.propTypes = propTypes;
